<template>
    <sidebar-menu
        :items="items"
        :active-page-folder="activePageFolder"
        has-icon
        @update:expanded="$emit('update:expanded', $event)"
    />
</template>

<script>
import SidebarMenu from '@/components/sidebar/SidebarMenu.vue';
import Dashboard from '@/models/Dashboard.js';

export default {
    name: 'PagesSidebar',

    components: { SidebarMenu },

    emits: ['update:expanded'],

    computed: {
        items() {
            return this.$store.state.entities.dashboard.activePageFolder?.items;
        },

        Dashboard() {
            return this.$store.state.entities.dashboard.activePageFolder;
        },

        activePageFolder() {
            return this.$store.state.entities.dashboard.activePageFolder;
        },
    },

    created() {
        const items = this.$store.getters['Menu/menu'];
        const activePageFolder = { title: 'home', items };
        this.$store.state.entities.dashboard.activePageFolder = activePageFolder;

        Dashboard.commit(state => {
            state.breadcrumb.push(activePageFolder);
        });
    },
};
</script>
